import { useEffect, useState } from 'react';
import { useForm } from '../../hooks';

import { Typography, Button, Grid, IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

import StyledModal from './StyledModal';
import TextField from '../common/TextField';
import colors from '../../assets/colors';
import { farm } from '../../utils/api';

export default function AddFarmModal(props) {
  const handleClose = () => props.setOpen(false);
  const [formValid, setFormValid] = useState(false);
  const handleAddFarm = () => {
    addFarm();
    handleClose();
  };

  const { handleChange, handleChangeNumber, values } = useForm({
    address: '',
    arimr: '',
    farmName: '',
    name: '',
    nip: '',
    pesel: '',
    surname: '',
  });

  useEffect(() => {
    if (
      values.arimr?.length < 9 ||
      values.nip?.length < 10 ||
      values.pesel?.length < 11 ||
      values.farmName?.length === 0 ||
      values.name?.length === 0 ||
      values.surname?.length === 0 ||
      values.address?.length === 0
    )
      setFormValid(false);
    else setFormValid(true);
  }, [values]);

  const addFarm = () => {
    const body = {
      address: values.address,
      arimr: values.arimr,
      farmName: values.farmName,
      name: values.name,
      nip: values.nip,
      pesel: values.pesel,
      surname: values.surname,
    };
    if (formValid) farm.add(body).then(() => props.update());
  };

  return (
    <StyledModal open={props.open}>
      <IconButton
        onClick={handleClose}
        sx={{
          color: colors.redButton,
          position: 'absolute',
          top: 5,
          right: 5,
        }}
      >
        <CancelIcon />
      </IconButton>
      <Grid container justifyContent="center">
        <Typography sx={{ fontSize: 36, fontWeight: 500, mb: 4, mt: 1 }}>
          Dodaj gospodarstwo
        </Typography>
      </Grid>
      <Grid container direction={'column'}>
        <Grid container>
          <TextField
            modal
            fullWidth
            label="Nazwa gospodarstwa"
            value={values.farmName}
            onChange={handleChange('farmName')}
            inputProps={{
              maxLength: 48,
            }}
          />
        </Grid>
        <Grid container justifyContent="left">
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <TextField
              modal
              label="Imię"
              value={values.name}
              onChange={handleChange('name')}
              inputProps={{
                maxLength: 15,
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <TextField
              modal
              label="Nazwisko"
              value={values.surname}
              onChange={handleChange('surname')}
              inputProps={{
                maxLength: 25,
              }}
            />
          </Grid>
        </Grid>
        <Grid container>
          <TextField
            modal
            label="PESEL"
            value={values.pesel}
            onChange={handleChangeNumber('pesel')}
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
              maxLength: 11,
            }}
            error={values.pesel?.length > 0 && values.pesel?.length < 11}
            helperText={
              values.pesel?.length < 11 && 'Numer PESEL składa się z 11 cyfr'
            }
          />
        </Grid>
        <Grid container justifyContent="left">
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <TextField
              modal
              label="Numer identyfikacyjny ARIMR"
              value={values.arimr}
              onChange={handleChangeNumber('arimr')}
              inputProps={{
                inputMode: 'numeric',
                pattern: '[0-9]*',
                maxLength: 9,
              }}
              error={values.arimr?.length > 0 && values.arimr?.length < 9}
              helperText={
                values.arimr?.length < 9 && 'Number ARIMR składa się z 9 cyfr'
              }
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <TextField
              modal
              label="NIP"
              value={values.nip}
              onChange={handleChangeNumber('nip')}
              inputProps={{
                inputMode: 'numeric',
                pattern: '[0-9]*',
                maxLength: 10,
              }}
              error={values.nip?.length > 0 && values.nip?.length < 10}
              helperText={values.nip?.length < 10 && 'NIP składa się z 10 cyfr'}
            />
          </Grid>
        </Grid>
        <Grid container>
          <TextField
            modal
            fullWidth
            label="Adres"
            value={values.address}
            onChange={handleChange('address')}
            inputProps={{
              maxLength: 200,
            }}
          />
        </Grid>
        <Grid
          container
          justifyContent="right"
          alignContent="right"
          alignItems="right"
        >
          <Button
            type="submit"
            variant="outlined"
            onClick={handleAddFarm}
            sx={{ mt: 2 }}
            disabled={!formValid}
          >
            Zapisz zmiany
          </Button>
        </Grid>
      </Grid>
    </StyledModal>
  );
}
